import { render, staticRenderFns } from "./SceneTemplate.vue?vue&type=template&id=226c2ed4&scoped=true&lang=pug&"
var script = {}
import style0 from "./SceneTemplate.vue?vue&type=style&index=0&id=226c2ed4&lang=scss&scoped=true&"
import style1 from "./SceneTemplate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c2ed4",
  null
  
)

export default component.exports